import { Box, useTheme } from "@mui/material";
import { PimoReactComponent } from "@pimo/pimo-app-builder";
import { Log } from "@pimo/pimo-components";

import { LogsPage } from "./logs-page";
import {
  LogsSearch,
  LogsSearchEventNames,
  LogsSearchEventPayload,
} from "./logs-search";

type LogsWithSearchProps = {
  logs: Log[];
  isLoading: boolean;
  fromDate?: string | null;
  untilDate?: string | null;
  selectedProject: string;
  selectedEditor: string;
  searchTerm: string;
  projects: Array<{ id: string; name: string }>;
  editors: Array<{ id: string; name: string }>;
  language?: string;
};

type LogsWithSearchEventNames = "overlay:load-more-logs" | LogsSearchEventNames;

export const LogsWithSearch: PimoReactComponent<
  LogsWithSearchProps,
  LogsWithSearchEventNames,
  LogsSearchEventPayload
> = ({
  logs,
  isLoading,
  fromDate,
  untilDate,
  selectedProject,
  selectedEditor,
  searchTerm,
  projects,
  editors,
  language,
  fireEvent,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        position: "fixed",
        top: "83px",
        left: "0",
        right: "0",
        bottom: "0",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: theme.palette.secondary.main,
        overflow: "hidden",
        zIndex: 1,
      }}
    >
      <Box
        data-scroll-container="logs-container"
        sx={{
          maxWidth: "1200px",
          width: "90%",
          height: "calc(100vh - 120px)",
          maxHeight: "calc(100vh - 120px)",
          margin: "0 auto",
          backgroundColor: "white",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          borderRadius: "12px",
        }}
      >
        <Box
          data-scroll-area="search-area"
          sx={{
            flexShrink: 0,
            borderBottom: `1px solid ${theme.palette.divider}`,
            borderRadius: "12px 12px 0 0",
            backgroundColor: "white",
            position: "sticky",
            top: 0,
            zIndex: 2,
          }}
        >
          <LogsSearch
            fromDate={fromDate}
            untilDate={untilDate}
            selectedProject={selectedProject}
            selectedEditor={selectedEditor}
            searchTerm={searchTerm}
            projects={projects}
            editors={editors}
            fireEvent={fireEvent}
          />
        </Box>

        <Box
          data-scroll-area="logs-area"
          sx={{
            flexGrow: 1,
            overflow: "auto",
            minHeight: 0,
            WebkitOverflowScrolling: "touch",
            borderRadius: "0 0 12px 12px",
          }}
        >
          <LogsPage
            logs={logs}
            isLoading={isLoading}
            language={language}
            fireEvent={fireEvent}
          />
        </Box>
      </Box>
    </Box>
  );
};
